<template>
  <div
    :class="['flex lg:flex-row flex-col', 'lg:h-120 h-160', 'bg_linear_to_r', '**:duration-500']"
  >
    <ULink
      v-for="(item, index) in videoList"
      :key="`business-${item.title}`"
      :to="item.to"
      :class="[
        'relative',
        'flex-1 hover:flex-3',
        'size-full overflow-hidden',
        'select-none',
        'group/business transition-all',
      ]"
      @mouseenter="playVideo(index)"
      @mouseleave="pauseVideo(index)"
      @touchmove.passive="playVideo(index)"
      @touchend="pauseVideo(index)"
    >
      <!-- 内容层 -->
      <div :class="['absolute z-1', 'size-full']">
        <!-- 标题 + 描述容器 -->
        <div
          :class="[
            'isolate',
            'flex flex-col group-hover/business:flex-row justify-center group-hover/business:justify-start items-center gap-2 group-hover/business:gap-5',
            // 过渡
            'transition-all',
            // 定位
            'absolute left-1/2 bottom-1/2 translate-y-1/2 -translate-x-1/2',
            // 悬浮后定位
            'group-hover/business:p-6 group-hover/business:w-full group-hover/business:bottom-0 group-hover/business:left-0 group-hover/business:translate-0',
            // 悬浮后背景
            'before:absolute before:-z-1 before:bottom-0 before:left-0',
            'before:h-full before:w-0 group-hover/business:before:w-full group-hover/business:before:delay-300',
            'before:bg-black/50',
            'before:mask-r-from-75% before:mask-r-to-100%',
            'before:transition-all before:duration-300',
          ]"
        >
          <UIcon
            :name="item.icon"
            :class="['lg:size-10 lg:group-hover/business:size-12 size-8', 'shrink-0', 'text-white']"
          />

          <div :class="['flex flex-col']">
            <!-- 标题容器 -->
            <div
              :class="[
                'flex flex-col group-hover/business:flex-row justify-center group-hover/business:justify-start items-center gap-2',
                'text-center group-hover/business:text-start text-shadow-md lg:text-2xl text-xl text-white lg:group-hover/business:text-primary font-bold uppercase transition-all',
              ]"
            >
              <h3>{{ item.title }}</h3>
            </div>

            <!-- 用 max-height 控制显示而不是visible，以此实现偏移过渡动画 -->
            <!-- ❗这里的group-hover/business:max-h-screen实际上太高了，但总比硬编码一个数值强 -->
            <div
              class="overflow-hidden transition-all max-h-0 group-hover/business:max-h-screen group-hover/business:w-3/4 delay-100"
            >
              <!-- 正文 -->
              <p class="text-white">
                {{ item.desc }}
              </p>
            </div>
          </div>

          <!-- 右下角绝对定位小容器 -->
          <!-- <div
          :class="[
            'absolute bottom-6 right-6',
            'flex items-center gap-2',
            'text-white/80',
            'transition-all',
            'opacity-0 group-hover/business:opacity-100 translate-y-10 group-hover/business:translate-y-0',
          ]"
        >
          <UIcon name="fe:arrow-right" />
        </div> -->
        </div>
      </div>

      <!-- 视频背景 -->
      <video
        :ref="
          el => {
            videoRefs[index] = el as HTMLVideoElement
          }
        "
        muted
        loop
        playsinline
        preload="metadata"
        :src="item.src"
        :class="[
          'absolute inset-0',
          'size-full object-cover',
          'transition-all',
          'brightness-75 group-hover/business:brightness-100 group-active/business:brightness-80',
        ]"
      />
    </ULink>
  </div>
</template>

<script lang="ts" setup>
  const { t } = useI18n()

  interface VideoList {
    src: string
    title: string
    icon: string
    desc: string
    to: string
  }

  /** 新闻卡片内容 */
  const videoList: VideoList[] = [
    {
      src: `/video/business/transport.mp4`,
      icon: 'mdi:truck-outline',
      title: t(`page.index.business.content.transport.title`),
      desc: t(`page.index.business.content.transport.desc`),
      to: `/business/transport`,
    },
    {
      src: `/video/business/storage.mp4`,
      icon: 'vaadin:storage',
      title: t(`page.index.business.content.storage.title`),
      desc: t(`page.index.business.content.storage.desc`),
      to: `/business/storage`,
    },
    {
      src: `/video/business/cold-chain.mp4`,
      icon: 'mdi:snowflake',
      title: t(`page.index.business.content.cold-chain.title`),
      desc: t(`page.index.business.content.cold-chain.desc`),
      to: `/business/cold-chain`,
    },
    {
      src: `/video/business/customs.mp4`,
      icon: 'mdi:briefcase-outline',
      title: t(`page.index.business.content.customs.title`),
      desc: t(`page.index.business.content.customs.desc`),
      to: `/business/customs`,
    },
  ]

  // 收集视频的 DOM 实例
  const videoRefs: HTMLVideoElement[] = []

  const playVideo = (index: number) => {
    // catch 防止浏览器策略拦截报错
    videoRefs[index]?.play().catch(() => {})
  }

  const pauseVideo = (index: number) => {
    videoRefs[index]?.pause()
  }
</script>
